import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { Download1_5px, Sizes } from "@/components/icon/IconList";
import { popupButtonClicked, popupViewed } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { CheckboxLabel, Dialog, DialogTitle, InteractionLayer, Typography } from "@bookips/sds";
import { useEffect, useState } from "react";
import { setSkipNPdfForToday } from "./utils/nPdfLocalStorage";
const actionTexts = {
    download: {
        subtitle: "어떤 자료를 다운로드할까요?",
        directLabel: "바로 다운로드",
        checkboxLabel: "오늘 하루 메인 자료만 받기"
    },
    view: {
        subtitle: "어떤 자료를 열람할까요?",
        directLabel: "바로 열람하기",
        checkboxLabel: "오늘 하루 메인 자료만 보기"
    }
};
// 리스트 아이콘 (함께 제공되는 자료 보러가기)
const ListIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3 5H17M3 10H17M3 15H17",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    });
const NPdfDialog = (param)=>{
    let { open , onOpenChange , count , actionType , onDirectAction , onGoToDetail , position ="자료보관함" , detailUrl =""  } = param;
    const [skipChecked, setSkipChecked] = useState(false);
    const texts = actionTexts[actionType];
    const title = count != null ? "함께 제공되는 ".concat(count, "개 자료가 있어요.") : "함께 제공되는 자료가 있어요.";
    const body = texts.subtitle;
    // mx-416: Popup Viewed
    useEffect(()=>{
        if (open) {
            popupViewed({
                Position: position,
                Type: "N개 PDF 포함 안내",
                Title: title,
                Body: body
            });
        }
    }, [
        open,
        position,
        title,
        body
    ]);
    const handleDirectAction = ()=>{
        // mx-417: Popup Button Clicked (바로 다운로드/열람)
        popupButtonClicked({
            Position: position,
            Type: "N개 PDF 포함 안내",
            Title: title,
            Body: body,
            "Button Name": texts.directLabel,
            "Button Url": null,
            DontShowToday: skipChecked
        });
        if (skipChecked) {
            setSkipNPdfForToday();
        }
        onOpenChange(false);
        onDirectAction();
    };
    const handleGoToDetail = ()=>{
        // mx-417: Popup Button Clicked (함께 제공되는 자료 보러가기)
        popupButtonClicked({
            Position: position,
            Type: "N개 PDF 포함 안내",
            Title: title,
            Body: body,
            "Button Name": "함께 제공되는 자료 보러가기",
            "Button Url": detailUrl,
            DontShowToday: skipChecked
        });
        onOpenChange(false);
        onGoToDetail();
    };
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: onOpenChange,
        classes: {
            contentWrapper: "flex flex-col w-[520px] max-w-[calc(100vw-40px)]"
        },
        title: /*#__PURE__*/ _jsx(DialogTitle, {
            title: count != null ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "함께 제공되는 ",
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-secondary-dark",
                        children: count
                    }),
                    "개 자료가 있어요."
                ]
            }) : "함께 제공되는 자료가 있어요.",
            description: texts.subtitle
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-3 px-7 pb-7 max-sm:px-5 max-sm:pb-5",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col rounded-md border border-gray-200",
                    children: [
                        /*#__PURE__*/ _jsx(InteractionLayer, {
                            as: "div",
                            className: "rounded-t-md",
                            children: /*#__PURE__*/ _jsxs("button", {
                                type: "button",
                                className: cn("flex w-full items-center gap-3 rounded-t-md px-5 py-4", "text-left"),
                                onClick: handleDirectAction,
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        icon: Download1_5px,
                                        size: Sizes.small,
                                        className: "shrink-0 text-gray-700"
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle1",
                                        className: "text-strong",
                                        children: texts.directLabel
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "border-t border-gray-100 px-4 py-3",
                            children: /*#__PURE__*/ _jsx(CheckboxLabel, {
                                checked: skipChecked,
                                onCheckedChange: (checked)=>setSkipChecked(Boolean(checked)),
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    className: "text-primary",
                                    children: texts.checkboxLabel
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(InteractionLayer, {
                    as: "div",
                    className: "rounded-md",
                    children: /*#__PURE__*/ _jsxs("button", {
                        type: "button",
                        className: cn("flex w-full items-center gap-3 p-4", "rounded-md border border-gray-200", "text-left"),
                        onClick: handleGoToDetail,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "shrink-0 text-gray-700",
                                children: /*#__PURE__*/ _jsx(ListIcon, {})
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle1",
                                className: "text-strong",
                                children: "함께 제공되는 자료 보러가기"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export default NPdfDialog;
